<script setup lang="ts">
import type { NavigationItemsCollectionItem } from '@fondof-ui/types'
import { localizeUrl } from '@shared/fondof-fn/url/localize'

import { ModellvergleichIcon } from '@fond-of/satch-icons'

defineProps<{
  navLink?: NavigationItemsCollectionItem
  locale: string
}>()
</script>

<template>
  <li
    class="md:w-22 mb-2.5 flex basis-1/3 list-none items-center justify-center px-0 lg:w-24 lg:basis-[100px]"
    :class="navLink?.specialClass"
  >
    <a
      class="relative block w-full text-[0.75rem] leading-[1.125rem] text-blue-600 lg:w-auto"
      gtm-data-attr="subnav_1"
      :gtm-data-label="navLink?.label"
      :href="localizeUrl(`/${navLink?.url || ''}`)"
    >
      <span class="navigation__image__model text-primary hidden pr-1.5">
        <ModellvergleichIcon
          width="15px"
          height="22px"
        />
      </span>
      <span class="navigation__item__image-wrapper flex justify-center">
        <img
          v-if="navLink?.image?.url"
          :alt="navLink?.image?.description || ''"
          class="max-w-full pb-[5px] max-sm:h-20"
          :src="`${navLink.image?.url}?w=200`"
        />
      </span>
      <span class="navigation__item__name text-primary block text-center">
        {{ navLink?.label }}
      </span>
    </a>
  </li>
</template>

<style scoped>
@media (max-width: 1279.98px) {
  .navigation__item--overview .navigation__item__image-wrapper {
    justify-content: flex-start;
  }

  .navigation__item--overview {
    flex-basis: 100%;
    margin-bottom: 30px;
    width: 100%;
  }

  .navigation__item--overview .navigation__item__name {
    position: absolute;
    bottom: -10px;
    text-align: left;
  }

  .navigation__item--overview--freetime {
    margin-top: 20px;
  }

  .navigation__item--modellvergleich .navigation__item__image-wrapper {
    display: none;
  }

  .navigation__item--modellvergleich {
    position: absolute;
    top: 135px;
    right: 30px;
    padding: 5px 0 0 !important;
    width: auto;
  }

  .navigation__item--modellvergleich .navigation__item__name {
    margin-top: 2px;
    text-align: left;
  }

  .navigation__item--modellvergleich .navigation__image__model {
    display: block;
  }

  .navigation__item--modellvergleich a {
    display: flex;
    align-items: center;
  }

  .navigation__item--bags-satch {
    flex-basis: 25%;
  }
}

@media (min-width: 640px) {
  .navigation__item--overview {
    width: auto;
  }
}

@media (min-width: 1280px) {
  /* Size correction for individual menu items */

  .navigation__item--overview .navigation__item__image-wrapper {
    min-height: 88px;
  }

  .navigation__item--overview--apparels .navigation__item__image-wrapper {
    min-height: 86px;
  }

  .navigation__item--overview--apparels {
    flex-basis: 125px;
  }

  .navigation__item--overview--accessories {
    flex-basis: 116px;
  }

  .navigation__item--overview--accessories .navigation__item__image-wrapper {
    min-height: 88px;
  }

  .navigation__item--overview--freetime {
    margin-left: 10px;
  }

  .navigation__item--overview--service {
    padding-right: 10px;
  }

  :not([lang='de']) .navigation__item--overview--school {
    flex-basis: 114px;
  }

  :not([lang='de']) .navigation__item--overview--travel {
    flex-basis: 110px;
  }
}

.navigation__item--overview--school {
  padding-right: 10px;
}

.navigation__item--overview {
  width: 100%;
}
</style>
